/**
 * 道具购买通用mixins
 * 主要是 Detail.vue 里通用的一部分逻辑
 * 该MIxin依赖组件里的
 *    donotUseCoupon
 *    selectedDiscountCoupon
 *    groupId
 *    busId
 *    goodsId
 *    openPromptPropBuy | closePropBuy
 *
 *   注意，因为有data依赖，其他模块不可直接使用改mixin，旨在代码模块切分而非复用
 */

import { mapGetters, mapActions } from "vuex"
import couponStatus from "@constants/couponState.js"
import * as mobileGameBusiness from "../../business/mobilegame"
import * as gameProps from "@api/gameProps"
import * as reportDict from "@constants/report-dictonary"
import * as enums from "@store/enums"
import * as url from "@utils/url"
import * as errorMaps from "@constants/error_map"
import * as CouponApi from "@api/coupon"
import * as helper from "@utils/helper"
import { FissionApi, fission } from "../../api/fission"
import Vue from "vue"
import { addGetParam } from "@tencent/midas-util"
import { PAGE_VIEW, CLICK } from "../../constants/report-dictonary"
import { pay as midasNewPay, payHandlers } from "../../business/pay"
import { pick } from "lodash"
import { handleErrorMessages, isLOLPcGame, LOL_PAY_NEED_CONFIRM } from "../../business/lolPc"
export default {
  data() {
    return {
      // 购买锁，如果用户点击购买后不可重复点击
      enableBuy: true
    }
  },

  computed: {
    ...mapGetters([
      "gameCoinBalance",
      "userAgent",
      "currentItem",
      "fromMini",
      "isBigRUser",
      "provideAccountType",
      "provideUin",
      "qqConnectNickname",
      "isQQConnectLoginState",
      "loginState",
      "pfSource",
      "pf",
      "sandbox",
      "sessionObj"
    ]),
    // 是否是端游专区
    isPcGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
    },
    // 是否是手游专区
    isMobileGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.MOBILE_GAME
    }
  },

  methods: {
    ...mapActions([
      "reportUserAction",
      "setToastMsg",
      "setDialogMsg",
      "setLoadingStart",
      "setLoadingEnd",
      "getUserSubscribe",
      "rechargeAMSGoods",
      "reportAndJump",
      "demandAMSGoods",
      "getTeamDetail"
    ]),

    /**
     * 判断业务层级+道具层级是否屏蔽点券支付
     * return true屏蔽 flse未屏蔽
     */
    checkPropDisableGameCoin(goods) {
      return goods && goods.dc && goods.dc.indexOf("game_coin") > -1
    },

    // 从查询的券列表中匹配到指定的抵扣券，并返回券状态
    findAndCheckDiscountCouponStatus({ codeId, batchId, couponsListRes }) {
      if (codeId && batchId && couponsListRes.ret === 0) {
        if (couponsListRes.mp_info && couponsListRes.mp_info.unicoupon_mpinfo && couponsListRes.mp_info.unicoupon_mpinfo.coupons) {
          let coupon = couponsListRes.mp_info.unicoupon_mpinfo.coupons.find(coupon => {
            return (
              coupon &&
              coupon.card_info &&
              coupon.card_info[0] &&
              coupon.card_info[0].batch_id === batchId &&
              coupon.card_info[0].batch_info &&
              coupon.card_info[0].batch_info[0].code_id === codeId
            )
          })
          if (coupon) return coupon.card_info[0].batch_info[0].status
        }
      }
      return 1
    },

    /***
     * 提交购买action
     * - 校验用户是否重复购买
     * - 校验使用抵扣券是否有效
     * @param goods 物品信息
     * @param payType 支付类型
     * @param selectAndCheckRole 是否校验角色
     * @param propsGroupActivity 团购活动信息
     * @param groupBuyState 端游团购活动登录态
     */
    commitBuy(opts) {
      let { goods, payType, userZoneInfo } = opts
      // 如果缓存用户已购买，则弹窗提示已拥有
      if (
        this.hasProp ||
        (goods.itemExtend &&
          goods.itemExtend.Singleton == 1 &&
          gameProps.checkLocalBuyedProp({
            openid: this.checkThirdSession && userZoneInfo?.bind_user_id ? userZoneInfo.bind_user_id : this.loginState.openid,
            gameid: userZoneInfo.gameid || "",
            productId: goods.itemExtend.AMSID,
            offerId: this.currentItem.ams.offerid
          }))
      ) {
        if (this.haveDiscountCard === false) {
          //没卡有皮肤的情况
          this.switchHasSkinNoCardDialog(true)
        } else {
          this.setDialogMsg(errorMaps.ERROR_MAP.HAS_PROP_BEFORE)
        }
        return
      }

      if (payType !== "inGameCoin" && !this.donotUseCoupon && gameProps.checkCouponExist(this.selectedDiscountCoupon)) {
        if (gameProps.checkCouponFrozen(this.selectedDiscountCoupon)) {
          // 用券，且券冻结状态，则弹窗解冻
          this.frozenCouponTips = errorMaps.USER_HELPER.FROZEN_COUPON_TEXT
          return
        } else if (
          (this.userAgent.weixinminiprogram || this.fromMini) &&
          this.userAgent.android &&
          !gameProps.checkCouponIsGameCoupon(this.selectedDiscountCoupon)
        ) {
          // 此逻辑只对DRM券有效
          // 在小程序内，需要再次确认券的状态再下单支付(因为小程序支付会冻结抵扣券，且不会自动解冻)
          this.enableBuy = false
          this.setLoadingStart()
          CouponApi.getCouponsList({
            offerId: this.currentItem.ams.offerid,
            pf: `${this.pfSource}-${this.pf}-${this.userAgent.iOS ? "iap" : "android"}`,
            loginState: helper.getLoginState(this.loginState),
            price: goods.saleCashPrice,
            sandbox: this.sandbox,
            productId: this.goodsId
          })
            .then(couponsRes => {
              this.enableBuy = true
              this.setLoadingEnd()
              let selectedDiscountCouponStatus = this.findAndCheckDiscountCouponStatus({
                codeId: this.selectedDiscountCoupon.codeId,
                batchId: this.selectedDiscountCoupon.batchId,
                couponsListRes: couponsRes
              })
              if (selectedDiscountCouponStatus & couponStatus.FROZEN) {
                this.frozenCouponTips = errorMaps.USER_HELPER.FROZEN_COUPON_TEXT
                return
              } else {
                this.userInfoConfirmBeforeBuy(opts)
              }
            })
            .catch(() => {
              this.enableBuy = true
              this.setLoadingEnd()
              // 查抵扣券失败，也继续下单支付
              this.userInfoConfirmBeforeBuy(opts)
            })
        } else if ((this.userAgent.weixinminiprogram || this.fromMini) && gameProps.checkCouponIsGameCoupon(this.selectedDiscountCoupon)) {
          // 小程序使用王者券下单
          this.enableBuy = false
          this.setLoadingStart()
          if (this.selectedDiscountCoupon?.coupon_id) {
            // 小程序带券下单选择微信支付时，需校验一下券是否有效
            this.checkGameCouponStatus({
              gameId: opts.userZoneInfo.gameid,
              gamePlatformId: opts.userZoneInfo.gamePlatformId,
              productId: goods.itemExtend.AMSID,
              couponId: this.selectedDiscountCoupon?.couponId
            })
              .then(res => {
                this.enableBuy = true
                this.setLoadingEnd()
                if (res?.coupons_info?.length) {
                  let frozenCoupon = res.coupons_info.find(coupon => {
                    return coupon?.coupon_status == "1" && coupon.coupon_id === this.selectedDiscountCoupon?.coupon_id
                  })
                  if (frozenCoupon) {
                    this.userInfoConfirmBeforeBuy(opts)
                  } else {
                    this.openPromptPropBuy({
                      promptText: `<p style='text-align: center;'>${errorMaps.COUPON_MSG.GREDEEM_FROZENCOUPON}</p>`,
                      confirmText: "确认",
                      confirmCb: () => {
                        this.closePropBuy()
                      },
                      closeCb: () => {
                        this.closePropBuy()
                      }
                    })
                  }
                }
              })
              .catch(() => {
                this.enableBuy = true
                this.setLoadingEnd()
                // 失败了也继续下单
                this.userInfoConfirmBeforeBuy(opts)
              })
          } else {
            this.enableBuy = true
            this.setLoadingEnd()
            this.userInfoConfirmBeforeBuy(opts)
          }
        } else {
          // 不在小程序内，直接下单支付
          this.userInfoConfirmBeforeBuy(opts)
        }
      } else {
        // 不使用抵扣券，直接下单支付
        this.userInfoConfirmBeforeBuy(opts)
      }
    },

    /***
     * 团购场景前置用户确认购买信息
     * @param goods 物品信息
     * @param payType 支付类型
     * @param selectAndCheckRole 是否校验角色
     * @param propsGroupActivity 团购活动信息
     * @param groupBuyState 端游团购活动登录态
     */
    userInfoConfirmBeforeBuy(opts) {
      let { goods, userZoneInfo, propsGroupActivity } = opts

      if (propsGroupActivity && propsGroupActivity.buyGroupId && propsGroupActivity.teamGroupid) {
        this.reportUserAction({
          iformat: reportDict.ANALYSE.TEAM_CONFIRM,
          resultInfo: {
            actKey: opts.propsGroupActivity.teamGroupid
          }
        })
        // 团购需要二次确认，是否购买到XXX大区，文案按照活动类型做切换
        let promptText = `<p style='text-align: left;margin-bottom: .1rem;'>确认消耗${
          goods?.showGameCoinPrice ? `${propsGroupActivity.salePrice}${this.currentItem.unit}` : `${propsGroupActivity.saleCashRMBPrice}元`
        }购买${
          this.currentProp.name
        }并参与拼团活动吗？</p><p style='text-align: left;margin-bottom: .1rem;'>支付成功后道具将发放到<span style='color: #C53338;font-weight: bolder;'>【${
          userZoneInfo.zoneName
        }】</span>游戏内邮箱中哦，请及时领取。</p>${
          propsGroupActivity.buyTips ? `<p style='text-align: left;'>${propsGroupActivity.buyTips}</p>` : ""
        }`
        if (propsGroupActivity.isPcGameGroupBuy && Number(this.currentItem.busId) === 95) {
          promptText = `<p style='text-align: left;margin-bottom: .1rem;'>确认购买${propsGroupActivity.salePrice}${
            this.currentItem.unit
          }并参与拼团活动吗？</p><p style='text-align: left;margin-bottom: .1rem;'>支付成功后, 游戏币将立即发放到当前购买账号中, 请注意余额变动。</p>${
            propsGroupActivity.buyTips ? `<p style='text-align: left;'>${propsGroupActivity.buyTips}</p>` : ""
          }`
        }
        this.openPromptPropBuy({
          promptText,
          cancleText: "取消",
          confirmText: "确认",
          confirmCb: () => {
            this.closePropBuy()
            if (this.isWzry(this.currentItem.busId)) {
              this.checkUserHasGroup(opts)
            } else {
              this.confirmBuyProps(opts)
            }
          },
          cancelCb: () => {
            this.closePropBuy()
          },
          closeCb: () => {
            this.closePropBuy()
          },
          interceptBuy: true
        })
      } else {
        this.confirmBuyProps(opts)
      }
    },

    /**
     * 团购前购买校验用户是否有团
     * @param {*} opts
     */
    checkUserHasGroup(opts) {
      this.enableBuy = false
      this.setLoadingStart()
      this.getTeamDetail({
        offerId: this.currentItem.ams.offerid,
        sandbox: this.sandbox,
        loginState: helper.getLoginState(opts.groupBuyState),
        drm_info: `group_id=${opts.propsGroupActivity.teamGroupid}&version=3.0`,
        partitionInfo: {
          game_platform_id: opts.userZoneInfo?.gamePlatformId,
          area: opts.userZoneInfo?.area,
          partition: opts.userZoneInfo?.partition
        },
        ...this.getQueryTeamDetailZoneId({ propsGroupActivity: opts.propsGroupActivity, userZoneInfo: opts.userZoneInfo }),
        // 如果地址上teamId表示，是来参团的。如果用户无团，查到的参团信息，页面状态不刷新；如果用户有团，查到的是用户的团，页面状态刷新为用户的团
        // 如果地址上没有teamId，表示用户只有开团。
        team_id: url.getParam("teamId") || "",
        pagesize: 50
      })
        .then(() => {
          this.enableBuy = true
          this.setLoadingEnd()
          // 判断是否在团里
          if (this.isInTeam) {
            this.setToastMsg("您已参与本次活动，请勿重复操作")
          } else {
            this.confirmBuyProps(opts)
          }
        })
        .catch(() => {
          this.enableBuy = true
          this.setLoadingEnd()
          this.setToastMsg(errorMaps.USER_HELPER.SYSTEM_BUSY)
        })
      this.reportUserAction({
        iformat: reportDict.ANALYSE.TEAM_PROC,
        resultInfo: {
          actKey: opts.propsGroupActivity.teamGroupid
        }
      })
    },

    getQueryTeamDetailZoneId({ propsGroupActivity, userZoneInfo }) {
      if (Number(propsGroupActivity.teamProcUseZoneID) === enums.TEAM_PROC_ZONEID.account) {
        return {
          zone_id: ""
        }
      } else if (Number(propsGroupActivity.teamProcUseZoneID) === enums.TEAM_PROC_ZONEID.zone) {
        return {
          zone_id: userZoneInfo?.zoneId?.split("_")[0]
        }
      } else {
        return {
          zone_id: userZoneInfo?.zoneId
        }
      }
    },

    /**
     * 确认使用金币||小程序支付||标准版支付
     * @param goods 物品信息
     * @param payType 支付类型
     * @param selectAndCheckRole 是否校验角色
     * @param propsGroupActivity 团购活动信息
     * @param groupBuyState 端游团购活动登录态
     */
    confirmBuyProps(opts) {
      let { payType, goods, propsGroupActivity, receiveFriend } = opts
      if (payType === "inGameCoin") {
        let promptText =
          (this.gameCoinBalance && this.gameCoinBalance.ingame_coin
            ? `<p>金币余额：<span class="gold-value">${this.gameCoinBalance.ingame_coin.balance}金币</span></p>`
            : "") +
          `<p>是否确认消耗 <span class="gold-value">${goods.goodsExtend.InGameCoinPrice}金币</span>，${this.getBtnText()}${goods.name}</p>`
        this.openPromptPropBuy({
          promptText,
          confirmCb: () => {
            this.closePropBuy()
            this.openMidasBuyAMS(opts)
          },
          cancelCb: () => {
            this.closePropBuy()
          },
          closeCb: () => {
            this.closePropBuy()
          },
          interceptBuy: true
        })
      } else if (payType === "gredeem_coupon") {
        // 如果使用了drm券进行兑换，需要拦截用户，因为不支持
        if (
          !this.donotUseCoupon &&
          this.selectedDiscountCoupon &&
          gameProps.checkCouponExist(this.selectedDiscountCoupon) &&
          !gameProps.checkCouponIsGameCoupon(this.selectedDiscountCoupon)
        ) {
          this.$Prompt({
            msgText: errorMaps.COUPON_MSG.GREDEEM_CANNOT_DRMCOUPON
          })
          return
        }

        // 如果皮肤卡价格小于实付价，前端拦截
        if (parseInt(this.selectedGredeemCoupon?.coupon_amt) < parseInt(this.showPriceInfo?.payPriceAmt)) {
          this.$Prompt({
            msgText: errorMaps.COUPON_MSG.GREDEEM_CANNOT_EXCHANGE
          })
          this.reportUserAction({
            iformat: reportDict.ERROR.GREDEEM_CONFIG,
            resultInfo: {
              couponId: this.selectedGredeemCoupon?.coupon_id
            }
          })
          return
        }

        let promptText = `<p>是否确认使用 <span class="gold-value">${this.selectedGredeemCoupon.coupon_name}</span>兑换${goods.name}</p>`
        this.openPromptPropBuy({
          promptText,
          confirmCb: () => {
            this.closePropBuy()
            this.openMidasBuyAMS({ ...opts, directChannel: "gredeem_coupon" })
          },
          cancelCb: () => {
            this.closePropBuy()
          },
          closeCb: () => {
            this.closePropBuy()
          },
          interceptBuy: true
        })
      } else {
        if ((this.userAgent.weixinminiprogram || this.fromMini) && this.userAgent.android && this.isMobileGame) {
          if (
            (propsGroupActivity && propsGroupActivity.buyGroupId && propsGroupActivity.teamGroupid) ||
            goods?.dc?.indexOf("wechat") > -1
          ) {
            // TODO 如果是团购购买，则只能支持点券支付，因为小程序支付会跳转商店结果页，不符合团购流程
            // 如果小程序内屏蔽了微信支付，则只支持点券支付，不应该展示支付方式弹窗
            this.openMidasBuyAMS({
              ...opts,
              directChannel: "game_coin"
            })
          } else if (this.checkPropDisableGameCoin(goods)) {
            // 如果该游戏不支持点券支付，直接拉起小程序支付，无需弹窗
            this.openMidasBuyAMS(opts)
          } else {
            // 安卓小程序内，点击立即购买弹窗选择微信支付或点券支付
            this.openPromptPropBuy({
              promptText: "<p style='text-align: center;'>请选择支付方式</p>",
              cancleText: "点券支付",
              confirmText: "微信支付",
              confirmCb: () => {
                this.closePropBuy()
                this.openMidasBuyAMS(opts)
              },
              cancelCb: () => {
                this.closePropBuy()
                this.openMidasBuyAMS({
                  ...opts,
                  directChannel: "game_coin"
                })
              },
              closeCb: () => {
                this.closePropBuy()
              },
              interceptBuy: true
            })
          }
        } else {
          this.openMidasBuyAMS(opts)
        }
      }

      // 以下为一系列上报
      if (this.isBigRUser) {
        this.reportUserAction({
          iformat: reportDict.BIGR.BUYGOODS,
          resultInfo: goods
        })
      }

      if (propsGroupActivity && propsGroupActivity.buyGroupId && propsGroupActivity.teamGroupid) {
        // 团购购买上报
        this.reportUserAction({
          iformat: propsGroupActivity.teamId ? reportDict.CLICK.DETAIL_TEAM_JOIN_BUY : reportDict.CLICK.DETAIL_TEAM_BUY,
          resultInfo: {
            actKey: propsGroupActivity.teamGroupid,
            productId: goods.itemExtend.AMSID
          }
        })
      } else {
        let selectedDiscountCoupon = null
        if (!this.donotUseCoupon && gameProps.checkCouponExist(this.selectedDiscountCoupon)) {
          selectedDiscountCoupon = this.selectedDiscountCoupon
        }

        let iformat = reportDict.CLICK.SERVICEZONE_SHELF_DETAIL_BUY
        if (payType === "inGameCoin") {
          iformat = reportDict.CLICK.SERVICEZONE_SHELF_DETAIL_INGAMECOIN_BUY
        }
        if (receiveFriend) {
          iformat = reportDict.CLICK.DETAIL_FRIEND_POPUP_SEND
        }
        this.reportUserAction({
          iformat,
          pfStructure: this.$route.query.pfStructure,
          resultInfo: {
            productId: goods.itemExtend.AMSID,
            goodsId: goods.itemId,
            subjectId: selectedDiscountCoupon ? selectedDiscountCoupon.couponId || selectedDiscountCoupon.batchId : ""
          }
        })

        try {
          this.reportUserAction({
            iformat: reportDict.ANALYSE.DETAIL_BUY,
            resultInfo: {
              productId: goods.itemExtend.AMSID,
              goodsInfo: goods?.goodsExtend,
              vmallMd5:
                (this.currentItem?.ams?.vmallConfigKey &&
                  window.__vmall_props_config_md5 &&
                  window.__vmall_props_config_md5[this.currentItem.ams.vmallConfigKey]) ||
                "",
              storeConfigEnv: url.getParam("store_config_env")
            }
          })
        } catch (error) {
          console.error(error)
        }
      }
    },

    /**
     * 买道具-下单
     * payType: inGameCoin 金币购买
     */
    openMidasBuyAMS({
      goods,
      payType = "midasH5Pay",
      selectAndCheckRole = true,
      directChannel = "",
      sepecifedProductId,
      saleCashPrice,
      userZoneInfo,
      propsGroupActivity,
      groupBuyState = "",
      receiveFriend = null,
      quantity = 1,
      pagedooProps = {},
      onClose,
      onSuccess
    }) {
      if (!(quantity > 0)) {
        this.setToastMsg("请输入正确的购买数量")
        return
      }

      this.enableBuy = false
      //如果是走新官网下单的物品从配置文件中取支付offerid
      let payOfferId = pagedooProps?.productId ? this.$store.getters.pfMapPagedoo.pagedoo_payOfferId : this.currentItem.ams.offerid
      // 场景1:正常场景，使用配置台道具offerid
      // 场景2:第三方场景，如电信币，需要使用电信币offerid支付
      // 场景3:特殊结算场景，如手Q店卖王者道具，需要用手Q申请的offerid支付结算
      if (url.getParam("biz_appid")) {
        payOfferId = url.getParam("biz_appid")
      } else if (this.currentItem?.ams?.bizAppid?.length) {
        let res = this.currentItem.ams.bizAppid.filter(biz => {
          return biz.pfSource == this.pfSource
        })
        if (res && res[0] && res[0].offerid) {
          payOfferId = res[0].offerid
        }
      }

      if (userZoneInfo?.zoneId && this.currentItem.ams?.disableZoneIdList?.split(",")?.includes(userZoneInfo.zoneId)) {
        this.setToastMsg("很抱歉，系统升级中，当前大区暂不支持购买")
        this.enableBuy = true
        return
      }

      let params = {
        payOfferId,
        onClose,
        onSuccess,
        pagedooProps,
        deliverOfferId: this.currentItem.ams.offerid,
        gameCoinOfferId: this.currentItem[this.userAgent.iOS ? "ios" : "android"][this.provideAccountType.toLowerCase()].offerid,
        // 专门给端游点券道具下单使用，表示购买数量
        quantity: this.isPcGame && goods?.goodsExtend?.CurrencyQuantity ? +goods?.goodsExtend?.CurrencyQuantity : quantity,
        // 强制走购物车1.0协议
        forceCartVersionOne: this.isPcGame && goods?.goodsExtend?.CurrencyQuantity ? true : false,
        // 团购场景，不需要传入provideUin
        provideUin: groupBuyState ? "" : this.provideUin,
        zoneId: selectAndCheckRole ? userZoneInfo.zoneId : 1,
        zoneName: selectAndCheckRole ? userZoneInfo.zoneName : "",
        gameid: selectAndCheckRole ? userZoneInfo.gameid : "",
        gamePlatformId: selectAndCheckRole ? userZoneInfo.gamePlatformId : "",
        clientVersion: this.isMobileGame && selectAndCheckRole ? (this.userAgent.iOS ? "iap" : "android") : "html5",
        productName: `${goods.name}${this.selectComboCard ? `和${this.currentProp?.specificDiscountCard?.name}` : ""}`,
        productId: sepecifedProductId || mobileGameBusiness.getVmallProductId(goods),
        productSalePrice: (saleCashPrice || goods.saleCashPrice) * quantity,
        payType,
        activityType: this.activityType,
        pfStructure: this.$route.query.pfStructure,
        gameType: this.isPcGame ? "pc" : "mobile",
        hashquery: this.$route.query,
        // 增加识别电信币购买道具的场景，前端传递is_pf_currency参数
        isPfCurrency: gameProps.handleConfigBySource({
          config: this.currentItem.bizAppidChannel,
          pfSource: url.getParam("biz_appid"),
          matchKey: "offerid"
        })?.channelInfo,
        // 团购登录态[仅有微信客户端并且是团购场景，而且是QQ互联登录态才会传入]
        groupBuyState:
          this.userAgent.weixin && propsGroupActivity && ["kp_actoken", "kp_accesstoken"].indexOf(groupBuyState?.sessionType) > -1
            ? groupBuyState
            : ""
      }

      // 传递vmall的goodsId，为了给后台在activityproc环节校验道具是否在线且可售卖
      if (goods?.goodsId) params.vmallGoodsId = goods.goodsId

      // TODO 如果是手Q游戏中心买猴子皮肤，需要使用王者手Q店铺里的vmallGoodsId
      if (goods?.goodsExtend?.BizAppid) {
        let bizAppidConfig = url.getParams(goods.goodsExtend.BizAppid, true)
        if (bizAppidConfig?.pfSource == this.pfSource && bizAppidConfig.vmallGoodsId) {
          params.vmallGoodsId = bizAppidConfig.vmallGoodsId
        }
      }

      // 处理活动号
      // 这里是折扣活动号处理
      if (gameProps.getGroupid(goods) && payType !== "inGameCoin") params.groupid = gameProps.getGroupid(goods)
      // 如果地址传入活动号，则替换当前活动号
      if (url.getParam("actid")) params.groupid = url.getParam("actid")

      // 这里是团购活动号处理，当有传入团购活动号。则覆盖折扣活动号
      // 特殊活动需要透传活动信息
      if (propsGroupActivity && propsGroupActivity.buyGroupId) {
        params.groupid = propsGroupActivity.buyGroupId

        if (propsGroupActivity.teamGroupid) {
          params.extendDrmInfo = {
            version: "3.0",
            team_id: propsGroupActivity.teamId || ""
          }
        }
      }

      if (directChannel) params.directChannel = directChannel
      // android && 小程序内 调标准版支付屏蔽点券渠道的充值回流 || 走第三方平台币道具直购offerid购买需要屏蔽平台币充值回流 || iOS标准版已屏蔽充值回流 || 走新官网下单买道具的充值回流
      if (
        (this.userAgent.android && (this.userAgent.weixinminiprogram || this.fromMini)) ||
        url.getParam("biz_appid") ||
        pagedooProps?.productId
      ) {
        params.disableReflow = true
      }

      // 抵扣券参数
      if (!this.donotUseCoupon && gameProps.checkCouponExist(this.selectedDiscountCoupon) && !this.selectComboCard) {
        params.selectedDiscountCoupon = this.selectedDiscountCoupon
      }
      // 礼品卡参数
      if (payType == "gredeem_coupon" && this.selectedGredeemCoupon?.coupon_id) {
        params.gredeem_coupon = this.selectedGredeemCoupon.coupon_id
      }

      // 第三方登录态下单
      if (this.checkThirdSession && userZoneInfo.bind_user_id && userZoneInfo.bind_user_type) {
        // 自定义provideInfo,传入第三方登录态绑定的账户信息，保证用户选角色和下单是一个绑定账号
        let provideInfoArr = []
        let provideInfoSingle = {
          provide_uin: userZoneInfo.bind_user_id,
          provide_uin_type: userZoneInfo.bind_user_type
        }
        if (Array.isArray(params.productId)) {
          params.productId.forEach(() => {
            provideInfoArr.push(provideInfoSingle)
          })
        } else {
          provideInfoArr.push(provideInfoSingle)
        }

        params.provideInfo = JSON.stringify(provideInfoArr)
        // 做购买缓存使用
        params.bindUserId = userZoneInfo.bind_user_id

        // 第三方登录态购买，需要实名认证，需要传递承载号的登录态
        // https://iwiki.woa.com/pages/viewpage.action?pageId=761495888
        if (userZoneInfo.bind_ori_user_id && userZoneInfo.bind_user_access_token && userZoneInfo.bind_user_type) {
          params.extend = `provide_uin=${userZoneInfo.bind_ori_user_id}&provide_no_type=${
            userZoneInfo.bind_user_type == "wechatid" ? "wechatid" : "openid"
          }&provide_session_token=${userZoneInfo.bind_user_access_token}&provide_session_type=${
            userZoneInfo.bind_user_type == "wechatid" ? "wc_actoken" : "kp_accesstoken"
          }&provide_qq_appid=${userZoneInfo.bind_user_type == "uin" ? userZoneInfo.bind_user_appid : ""}&provide_wx_appid=${
            userZoneInfo.bind_user_type == "wechatid" ? userZoneInfo.bind_user_appid : ""
          }`
        } else {
          console.log("第三方登录态购买需要实名认证，需要承载号信息！")
          return
        }
      }

      if (receiveFriend) {
        params.receiveFriend = receiveFriend
        // 赠送场景不支持背包过滤
        params.no_filter_goods = true
        // 赠送场景需要把承载号信息传入
        let provideInfoArr = []
        let provideInfoSingle = {
          product_type: "gredeem_coupon",
          partition: receiveFriend.partition,
          uid: receiveFriend.uid,
          platid: receiveFriend.platid,
          area: receiveFriend.area
        }
        if (Array.isArray(params.productId)) {
          params.productId.forEach(() => {
            provideInfoArr.push(provideInfoSingle)
          })
        } else {
          provideInfoArr.push(provideInfoSingle)
        }
        params.provideInfo = JSON.stringify(provideInfoArr)
      }

      // LOL 的特殊逻辑
      // https://git.woa.com/midas/store-daoju-proj/blob/develop/static/js/store/store_buy.js#L645-655
      if (isLOLPcGame(this.currentItem.busId)) {
        // 强制走 V2 协议
        params.forceProtocolV2 = true
        // 强制指定 zoneId 为 1
        params.zoneId = 1
      }

      let txParam = {}
      let waterParam = {}
      let nickParam = {}

      // 传入头像和昵称
      nickParam = {
        head_img: propsGroupActivity?.head_img,
        nick_name: propsGroupActivity?.nick_name
      }
      // 必须参数
      if (url.getParam("mediaProductId")) txParam.media_product_id = url.getParam("mediaProductId")
      if (url.getParam("tx_chan_type")) txParam.tx_chan_type = url.getParam("tx_chan_type")
      if (url.getParam("tx_trace_key")) txParam.tx_trace_key = url.getParam("tx_trace_key")
      if (url.getParam("tx_seller_id")) txParam.tx_seller_id = url.getParam("tx_seller_id")
      if (url.getParam("tx_buyer_id")) {
        txParam.tx_buyer_id = url.getParam("tx_buyer_id")
      } else if (this.loginState.openid && txParam.tx_chan_type) {
        txParam.tx_buyer_id = String(this.loginState.openid)
      }
      if (url.getParam("channels_seller_id")) {
        txParam.channels_seller_id = url.getParam("channels_seller_id")
        txParam.tx_seller_id = url.getParam("channels_seller_id")
      }
      if (url.getParam("channels_vid")) txParam.channels_vid = url.getParam("channels_vid")

      if (txParam.tx_chan_type) {
        //account可能有emoji表情，需要encode，否则buy_goods_m会报错
        waterParam = {
          accountType: this.provideAccountType.toLowerCase(),
          account: encodeURIComponent(" "),
          categoryId: this.currentItem.categoryId,
          zoneName: selectAndCheckRole ? userZoneInfo.zoneName : "",
          bizOfferId: this.currentItem.ams.offerid,
          busName: encodeURIComponent(this.currentItem.name),
          productItemId: goods && goods.itemId ? goods.itemId : ""
        }
      }

      params.extendData = {
        ...txParam,
        ...waterParam,
        ...nickParam
      }

      if (pagedooProps?.productId) {
        this.secKillBuy({
          params,
          userZoneInfo
        })
          .then(res => {
            res &&
              this.completeRechargeAMSGoods({
                activityToken: {
                  mid: "r",
                  token: res?.placeOrderResult?.data?.token,
                  url_params: res?.placeOrderResult?.data.url_params
                },
                goods,
                params,
                selectAndCheckRole,
                userZoneInfo,
                propsGroupActivity
              })
          })
          .catch(e => {
            this.enableBuy = true
            if (
              e?.err?.resultCode == "1018" &&
              (url.getParam("sessiontype") == "st_local_third_party" || url.getParam("sessiontype") == "st_third_party")
            ) {
              this.setToastMsg(errorMaps.USER_HELPER.THIRD_INVALID_SESSION)
            } else {
              this.setToastMsg(e?.msg)
            }
          })
      } else {
        this.payAMSGoods(params)
          .then(res => {
            res &&
              this.completeRechargeAMSGoods({
                activityToken: res,
                goods,
                params,
                selectAndCheckRole,
                userZoneInfo,
                propsGroupActivity
              })
          })
          .catch(res => {
            this.enableBuy = true

            if (res.err_code == "3702-3702-0") {
              //已拥有60卡文案
              this.setToastMsg("您已拥有该物品，不可重复购买哦～")
              return
            }

            if (res.err_code == "1001-3243-0") {
              this.setToastMsg("您绑定的游戏账号已变更，请重新选择角色")
              return
            }

            if (res.err_code == "2322-1298-0") {
              this.setToastMsg("当前道具已下架，去看看其他商品吧~")
              return
            }

            // 如果第三方登录态 && 绑定登录态失效 则提示重新绑定
            if (
              res.ret == "1018" &&
              (url.getParam("sessiontype") == "st_local_third_party" || url.getParam("sessiontype") == "st_third_party")
            ) {
              this.setToastMsg(errorMaps.USER_HELPER.THIRD_INVALID_SESSION)
              this.updateInvalidSession(true)
              return
            }

            // LOL端游特殊处理
            if (isLOLPcGame(this.currentItem.busId)) {
              const interceptMsg = handleErrorMessages(res, goods.propsList)
              if (interceptMsg) {
                this.openPromptPropBuy({
                  promptText: interceptMsg,
                  confirmCb: () => {
                    this.closePropBuy()
                  }
                })
                return
              }
            }

            // cgi过滤背包处理
            // "" ：表示可以购买
            // 2310：表示已经拥有这个物品
            // 2311：没有对应英雄
            // 2311，2310：没有对应英雄并且有这个物品
            // 2312：表示星元皮肤依赖的皮肤没有
            // 2316: 需要强依赖拥有某个物品才能购买（强依赖）
            if (res.errCode && res.errCode === 2311) {
              this.openPromptPropBuy({
                promptText: `您还没有${goods.itemExtend.HeroName}英雄，是否继续${this.getBtnText()}皮肤`,
                confirmCb: () => {
                  this.closePropBuy()
                  this.completeRechargeAMSGoods({
                    activityToken: res,
                    goods,
                    params,
                    selectAndCheckRole,
                    userZoneInfo,
                    propsGroupActivity
                  })
                },
                cancelCb: () => {
                  this.closePropBuy()
                },
                interceptBuy: true
              })
            } else if (res.errCode && res.errCode === 2312) {
              this.openPromptPropBuy({
                promptText: goods?.itemExtend?.RelyItemId
                  ? `您还没有${goods.itemExtend.RelyItemName || ""}皮肤，是否继续${this.getBtnText()}星元皮肤?`
                  : `您还没有${goods.itemExtend.RelyItemName || ""}，是否继续${this.getBtnText()}该道具?`,
                confirmCb: () => {
                  this.closePropBuy()
                  this.completeRechargeAMSGoods({
                    activityToken: res,
                    goods,
                    params,
                    selectAndCheckRole,
                    userZoneInfo,
                    propsGroupActivity
                  })
                },
                cancelCb: () => {
                  this.closePropBuy()
                },
                interceptBuy: true
              })
            } else if (res.errCode && res.errCode === 2313) {
              this.openPromptPropBuy({
                promptText: `您已拥有套装中的部分单品，是否继续${this.getBtnText()}完整套装?`,
                confirmCb: () => {
                  this.closePropBuy()
                  this.completeRechargeAMSGoods({
                    activityToken: res,
                    goods,
                    params,
                    selectAndCheckRole,
                    userZoneInfo,
                    propsGroupActivity
                  })
                },
                cancelCb: () => {
                  this.closePropBuy()
                },
                interceptBuy: true
              })
            } else if (res.errCode && res.errCode === 2314) {
              this.openPromptPropBuy({
                promptText: `已拥有当前最新战令，无需重复${this.getBtnText()}`,
                confirmCb: () => {
                  this.closePropBuy()
                }
              })
            } else if (res.errCode && res.errCode === 2315) {
              this.openPromptPropBuy({
                promptText: `已拥有当前最新战令，无需重复${this.getBtnText()}`,
                confirmCb: () => {
                  this.closePropBuy()
                }
              })
            } else if (res.errCode && res.errCode === 2316) {
              this.openPromptPropBuy({
                promptText: `您还没有${goods.itemExtend.RelyItemName || ""}，暂时无法${this.getBtnText()}该道具`,
                confirmCb: () => {
                  this.closePropBuy()
                }
              })
            } else if (res.errCode && res.errCode === 2310) {
              if (this.selectComboCard) {
                //66卡打包购买的时候如果卡已经有了
                this.openPromptPropBuy({
                  promptText: "您已拥有其中一个物品,无法打包购买哦",
                  confirmCb: () => {
                    this.closePropBuy()
                  },
                  cancelCb: () => {
                    this.closePropBuy()
                  },
                  interceptBuy: true
                })
              } else if (this.haveDiscountCard === false) {
                //没卡有皮肤的情况
                this.switchHasSkinNoCardDialog(true)
              } else if (res.boughtProduct && res.boughtProduct.length && res.boughtProduct.length < params.productId.length) {
                const filteredOwnProduct = mobileGameBusiness.filterOwnedProduct({
                  ownedProductIdList: res.boughtProduct,
                  goods,
                  vmallConfigByAMSID: this.vmallConfigByAMSID,
                  rate: this.currentItem.rate
                })
                this.openPromptPropBuy({
                  promptText: `您已拥有${filteredOwnProduct.ownedProductNames}，是否继续消耗${
                    filteredOwnProduct.currentPrice
                  }点券${this.getBtnText()}礼包内其他道具？`,
                  confirmCb: () => {
                    this.closePropBuy()
                    this.openMidasBuyAMS({
                      goods,
                      sepecifedProductId: filteredOwnProduct.canBuyProduct,
                      saleCashPrice: filteredOwnProduct.currentPrice * this.currentItem.rate,
                      selectAndCheckRole,
                      userZoneInfo
                    })
                  },
                  cancelCb: () => {
                    this.closePropBuy()
                  },
                  interceptBuy: true
                })
              } else {
                this.setDialogMsg(errorMaps.ERROR_MAP.HAS_PROP_BEFORE)
              }
            } else if (res.errCode && res.errCode === LOL_PAY_NEED_CONFIRM) {
              // LOL 物品相关提示
              this.openPromptPropBuy({
                promptText: res.errMessage,
                confirmCb: () => {
                  this.closePropBuy()
                  this.completeRechargeAMSGoods({
                    activityToken: res,
                    goods,
                    params,
                    selectAndCheckRole,
                    userZoneInfo,
                    propsGroupActivity
                  })
                },
                cancelCb: () => {
                  this.closePropBuy()
                },
                interceptBuy: true
              })
            } else {
              this.setToastMsg(errorMaps.USER_HELPER.SYSTEM_BUSY)
            }

            this.reportUserAction({
              iformat: reportDict.ANALYSE.ACTIVITY_PROC_CATCH
            })
          })
      }

      this.reportUserAction({
        iformat: reportDict.ANALYSE.ACTIVITY_PROC,
        resultInfo: {
          productId: goods.itemExtend.AMSID,
          params: params
        }
      })
    },
    /**
     * 秒杀活动
     * 走新官网下单方法
     */
    secKillBuy({ userZoneInfo, params }) {
      const product_list = [params.pagedooProps.productId].map(product_id => ({
        area: userZoneInfo.area,
        partition: userZoneInfo.partition,
        platid: userZoneInfo.gamePlatformId,
        product_id: product_id,
        provide_offer_id: params.pagedooProps.provideOfferId,
        quantity: params.quantity,
        roleid: userZoneInfo.roleId,
        zoneid: userZoneInfo.zoneId,
        rolename: userZoneInfo?.roleName,
        zonename: userZoneInfo?.zoneName
      }))

      const payParam = {
        app_id: this.$store.getters.pfMapPagedoo.pagedoo_appid,
        app_metadata: JSON.stringify(pick(params.extendData, ["tx_seller_id", "tx_buyer_id"])),
        offer_id: this.$store.getters.pfMapPagedoo.pagedoo_payOfferId,
        pf: `${this.$store.getters.pfSource}-${this.$store.getters.pf}${
          params.pfStructure ? `.${params.pfStructure.replace(/-/g, "_")}` : ""
        }-${params.clientVersion}`,
        product_list,
        res_offer_id: params.pagedooProps.resOfferId,
        resourceid: params.pagedooProps.resourceid,
        roleid: userZoneInfo.roleId,
        zoneid: userZoneInfo.zoneId,
        content_id: params.pagedooProps.activityId,
        seckill_param: {
          app_id: this.$store.getters.pfMapPagedoo.pagedoo_appid,
          activity_id: params.pagedooProps.activityId,
          model_id: params.pagedooProps.modelId,
          session_id: params.pagedooProps.secKillSessionId,
          order_id: params.pagedooProps?.orderId || ""
        }
      }
      return midasNewPay(
        payParam,
        {
          openid: this.loginState.openid,
          openkey: this.loginState.openkey,
          session_id: this.loginState.sessionId,
          session_type: this.loginState.sessionType,
          wx_appid: this.loginState.wxAppid2,
          qq_appid: this.loginState.qqAppid || "",
          offer_id: this.$store.getters.pfMapPagedoo.pagedoo_payOfferId
        },
        payHandlers,
        {
          fn: this.openPromptPropBuy,
          confirm: this.closePropBuy,
          close: this.closePropBuy
        }
      )
    },
    // 调支付，完成支付后跳转结果页
    completeRechargeAMSGoods({ activityToken, goods, params, selectAndCheckRole, userZoneInfo, propsGroupActivity, continueBuy }) {
      if (this.haveDiscountCardCoupon === false && this.haveDiscountCard === true && !continueBuy) {
        //用户有60卡没券，提示用户领券
        this.openPromptPropBuy({
          promptText: `
                    <p style="text-align: center">有皮肤专属抵扣券未领取哦！</p>
            `,
          confirmText: "去领券",
          confirmCb: () => {
            this.closePropBuy()
            this.receiveDiscountCard()
          },
          cancleText: "继续购买",
          cancelCb: () => {
            this.closePropBuy()
            this.completeRechargeAMSGoods({
              activityToken,
              goods,
              params,
              selectAndCheckRole,
              userZoneInfo,
              propsGroupActivity,
              continueBuy: true
            })
          },
          interceptBuy: true
        })
        this.enableBuy = true
        return
      }
      params.activityToken = activityToken
      this.enableBuy = false

      // 结果页参数
      let resultInfo = {
        n: params.quantity,
        accountType: this.provideAccountType,
        account: this.getAccountName({ userZoneInfo }),
        name: goods.name,
        categoryId: this.currentItem.categoryId,
        zoneName: selectAndCheckRole ? userZoneInfo.zoneName : "",
        action: "zoneResult",
        groupId: this.groupId,
        busId: this.busId,
        gameid: userZoneInfo.gameid,
        productId: goods.itemExtend.AMSID,
        bizOfferId: this.currentItem.ams.offerid
      }

      if (gameProps.isOuterScene()) {
        resultInfo.type = "outer"
      }

      if (gameProps.isAnchorOuterScene()) {
        //外部带货场景屏蔽推荐，商店广告位，需要显示主播信息和主播广告
        resultInfo.disable_return_back = 1
        resultInfo.busName = encodeURIComponent(this.currentItem.name)
        resultInfo.productItemId = goods.itemId
      }

      if (gameProps.isDialogMode()) {
        resultInfo.returnBackText = "关闭"
        if (url.getParam("disableHomeIcon")) resultInfo.disableHomeIcon = 1
      }

      if (url.getParam("returnAppText")) {
        //外部带货场景屏蔽推荐，商店广告位，需要显示主播信息和主播广告
        resultInfo.returnAppText = url.getParam("returnAppText")
      }

      if (params.receiveFriend) {
        resultInfo = {
          ...resultInfo,
          roleName: encodeURIComponent(userZoneInfo.roleName),
          send_openid: params.receiveFriend.sender_openid,
          send_gameid: params.gameid,
          send_game_platform_id: params.gamePlatformId,
          receive_openid: params.receiveFriend.openid,
          receive_gameid: `${params.receiveFriend.area}___${params.receiveFriend.partition}`,
          receive_game_platform_id: params.receiveFriend.platid,
          item_id: goods.itemId,
          item_type: goods?.itemExtend?.ReceiveItemType
        }
      }

      if (this.selectComboCard) {
        //60卡打包购买
        params.is60CardCombo = true
      }

      params.singleton = goods.itemExtend && goods.itemExtend.Singleton == 1 ? 1 : ""

      // 如果是预售商品，则缓存购买记录的时候，要同时缓存正式商品的ID，保证正式商品也提示"已购买"
      if (
        params.singleton &&
        params.productId &&
        goods &&
        goods.goodsExtend &&
        goods.goodsExtend.ActivityType === "preOrder" &&
        goods.goodsExtend.CommonAMSID
      ) {
        params.buyedCacheProductId = `${params.productId},${goods.goodsExtend.CommonAMSID}`
      }

      // 如果是有依赖关系的道具，则缓存购买记录的时候，要同时缓存关联商品的ID，保证其他商品也提示"已购买" || 例如：王者战令
      if (params.productId && goods?.goodsExtend?.FilterRule) {
        params.propsFilterRule = goods?.goodsExtend?.FilterRule
      }

      params.rechargeInfo = {
        ...resultInfo,
        zoneid: userZoneInfo.zoneId,
        product_name: goods.name
      }

      params.dc = (goods && goods.dc) || ""
      if (goods && goods.goodsExtend && goods.goodsExtend.DisableDc == 1) {
        params.disableDc = true
      }

      // ItemId透传到下单流水使用
      if (goods && goods.itemId) {
        params.productItemId = goods.itemId
      }

      this.rechargeAMSGoods(params)
        .then(msg => {
          //支付成功
          this.enableBuy = true

          if (msg === "success") {
            this.noticeSuccess()

            // 团购道具成功后不去结果页
            if (propsGroupActivity && propsGroupActivity.buyGroupId && propsGroupActivity.teamGroupid) {
              // 支付成功后弹窗用户可以选择是否订阅
              const checkSubscribe = () => {
                if (propsGroupActivity.subscribeGroups) {
                  let action = this.promptSubscribeStatus ? "subscribe" : "cancel"
                  this.getUserSubscribe({
                    groups: propsGroupActivity.subscribeGroups,
                    action: action,
                    loginState: params.groupBuyState
                  }).then(() => {
                    // 需要更新updateSubscribeGroups
                    this.updateSubscribeGroups({
                      groupId: propsGroupActivity?.subscribeGroups,
                      isDelete: action == "cancel" ? true : false
                    })
                  })
                }
              }
              this.openPromptPropBuy({
                promptText:
                  "<p style='text-align: center;'>支付成功！</p><p style='text-align: center;'>道具将发放到游戏邮箱哦，请尽快领取~</p>",
                cancleText: "取消",
                confirmText: "邀请好友参团",
                promptHasSubscribe: propsGroupActivity.subscribeGroups ? true : false,
                confirmCb: () => {
                  checkSubscribe()
                  this.closePropBuy()
                  if (this.$refs.groupBuyRef && this.$refs.groupBuyRef?.paySuccessAction)
                    this.$refs.groupBuyRef?.paySuccessAction({ inviteFriends: true })
                },
                cancelCb: () => {
                  checkSubscribe()
                  this.closePropBuy()
                  if (this.$refs.groupBuyRef && this.$refs.groupBuyRef?.paySuccessAction) this.$refs.groupBuyRef?.paySuccessAction()
                },
                closeCb: () => {
                  checkSubscribe()
                  this.closePropBuy()
                  if (this.$refs.groupBuyRef && this.$refs.groupBuyRef?.paySuccessAction) this.$refs.groupBuyRef?.paySuccessAction()
                }
              })
              this.reportUserAction({
                iformat: reportDict.PAGE_VIEW.DETAIL_TEAM_PAY_SUCC,
                resultInfo: {
                  actKey: propsGroupActivity.teamGroupid
                }
              })
            } else if (propsGroupActivity && propsGroupActivity.buyGroupId && propsGroupActivity.fissionGroupId) {
              this.goToActFissionProcess()
            } else {
              this.$router.push({
                path: "/result",
                query: resultInfo
              })
            }

            if (params?.selectedDiscountCoupon) {
              this.reportUserAction({
                iformat: gameProps.checkCouponIsGameCoupon(params.selectedDiscountCoupon)
                  ? reportDict.SUCC.RESULT_WITH_GAMECOUPON
                  : reportDict.SUCC.RESULT_WITH_DRMCOUPON
              })
            }
          }
        })
        .catch(error => {
          this.enableBuy = true

          // 报错：点券余额不足（1004）
          if (error && error.ret !== 0 && error.msg) {
            this.openPromptPropBuy({
              promptText: `<p style='text-align: center;'>${error.msg}</p>`,
              confirmText: "确认",
              confirmCb: () => {
                this.closePropBuy()
              },
              closeCb: () => {
                this.closePropBuy()
              }
            })
          }

          // 带王者券下单取消，需要确认是否要回滚券 || 2-1003-0-0带王者券兑换失败，需要确认是否要回滚券
          if (error && (error.ret == "1-1003-0-0" || error.ret == "2-1003-0-0") && error.couponId) {
            this.checkGameCouponStatus({
              gameId: error.gameid,
              gamePlatformId: error.gamePlatformId,
              productId: this.goodsId,
              couponId: error.couponId
            }).then(res => {
              // 如果存在冻结券，则提示用户去激活
              if (res?.coupons_info?.length) {
                let frozenCoupon = res.coupons_info.filter(coupon => {
                  return coupon?.coupon_status == "2"
                })
                if (frozenCoupon?.length > 0) {
                  this.openPromptPropBuy({
                    promptText: `<p style='text-align: center;'>${
                      error.ret == "1-1003-0-0" ? errorMaps.COUPON_MSG.FROZENCOUPON : errorMaps.COUPON_MSG.GREDEEM_FROZENCOUPON
                    }</p>`,
                    confirmText: "确认",
                    confirmCb: () => {
                      this.closePropBuy()
                    },
                    closeCb: () => {
                      this.closePropBuy()
                    }
                  })
                }
              }
            })
          }

          // 礼品卡兑换一旦有报错，应该刷新皮肤卡请求 || 优惠券如果有冻结的会引导用户去激活
          if (error && error.ret == "2-1003-0-0") {
            this.checkGredeemCouponCard({ userZoneInfo, productid: this.goodsId })
          }
        })
      this.reportUserAction({
        iformat: reportDict.ANALYSE.BEFORE_ACTIVITY_PROC,
        resultInfo: {
          params
        }
      })
    },

    getAccountName({ userZoneInfo }) {
      let account = "微信帐户"
      if (this.provideAccountType == enums.ACCOUNT_TYPE.QQ) {
        if (this.isPcGame) {
          account = this.provideUin || this.qqConnectNickname
        } else if (userZoneInfo && userZoneInfo.bind_user_id) {
          account = userZoneInfo.bind_user_id
        } else {
          account = this.isQQConnectLoginState ? this.qqConnectNickname : this.loginState.openid
        }
      }
      return account
    },

    //通知父级页面支付成功
    noticeSuccess() {
      if (gameProps.isDialogMode()) {
        parent?.postMessage &&
          parent.postMessage(
            {
              action: "success"
            },
            "*"
          )
      }
    },

    /**
     * 发起用户裂变活动
     */
    async goToActFissionProcess() {
      this.setLoadingStart()
      this.reportUserAction({
        iformat: PAGE_VIEW.DETAIL_FISSION_PROCESS
      })

      let { fissionGroupId, fissionPoster } = this.propsGroupActivity

      const fissionApiObj = new FissionApi({
        sandbox: this.sandbox,
        offerId: this.offerId,
        sessionObj: this.sessionObj
      })

      const fissionRes = await fission(fissionApiObj, fissionGroupId)

      this.setLoadingEnd()

      // 裂变成功，显示海报
      if (fissionRes.ret === 0) {
        Vue.$showFissionPoster({
          root: this,
          postInfo: fissionPoster,
          fissionId: fissionRes.info.fission_id,
          groupId: fissionGroupId
        })
        return
      }

      // 若没有配置裂变集合页，则什么也不做
      if (!fissionPoster.fissionList) {
        return
      }

      // 查不到用户的券，则提示用户去分享页面
      Vue.$Prompt({
        confirmText: "立即分享",
        msgText: "购买成功！点击分享，立刻送给好友晶石宝箱哦~",
        onConfirm: () => {
          this.goToFissionListPage("dialog")
        }
      })

      this.reportUserAction({
        iformat: PAGE_VIEW.DETAIL_FISSION_EMPTY
      })
    },

    /**
     * 跳转到裂变券集合页面
     */
    goToFissionListPage(pfStructure) {
      let { fissionGroupId, fissionPoster } = this.propsGroupActivity

      // 获得集合页的pf
      const getFissionListPageUrl = () => {
        return addGetParam(
          {
            pf: this.pf,
            sandbox: this.sandbox
          },
          `${fissionPoster.fissionList}&groupId=${fissionGroupId}`
        )
      }

      // 跳转到集合页面
      this.reportAndJump({
        target: getFissionListPageUrl(),
        iformat: `${CLICK.FISSION_LIST_PAGE_DIALOG}${pfStructure || "default"}`
      })
    }
  }
}
